// @flow
import styled from 'styled-components'
import { Layout } from 'antd'
const { Content } = Layout

export const StyledContent = styled(Content)`
  background: #fff;
  margin: 24px 16px;
  min-height: 50vh;
  padding: 0;
  
  .ant-timeline {
    margin-top: 20px;
  }
  
 .title {
    font-size: 23px;
    margin-top: 10px;
    
    input {
      font-size: 23px;
      margin-top: 10px;
    }
    .anticon {
      margin-left: 10px;
    }
 }
 
 .tabs {
    border-bottom: 2px solid #eee;
   .section {
      max-width: 600px;
      padding: 15px 0;
   }
   .trade-plan {
     .ant-row {
        margin-top: 15px;
     }
   }
 }
 
 .ant-col-24 {
  padding: 10px 0;
 }
 
 input[type=text] {
  width: 190px;
 }
 
 input[type=text].tradeName {
    width: 100%;
 }
  
  .summary {
    max-width: 500px;
    > div {
      display: flex;
      div {
        flex: 1;
      }
      div:first-child {
        flex: 2;
      }
   }
  
`

export const StyledCapital = styled.span`
  text-transform: uppercase;
`





// WEBPACK FOOTER //
// ./src/components/own-positions/style.js